import React from 'react';
import { Link } from 'react-router-dom';
import PageContainer from '../components/common/PageContainer';
import { imagePath } from '../utils/imagePath';

/**
 * AboutUsPage - About us page
 * Follows React Rules: Pure component, composed of smaller components
 */
const AboutUsPage = () => {
  const counters = [
    { number: 5000, label: 'HAPPY CUSTOMERS', icon: 'about-us/icon/1.png', bgClass: 'white-smoke-bg' },
    { number: 1000, label: 'VERIFIED SELLERS', icon: 'about-us/icon/2.png', bgClass: 'gray-bg' },
    { number: 50000, label: 'PRODUCTS AVAILABLE', icon: 'about-us/icon/3.png', bgClass: 'white-smoke-bg' },
    { number: 100, label: 'CATEGORIES', icon: 'about-us/icon/4.png', bgClass: 'gray-bg' }
  ];


  return (
    <PageContainer>
      {/* Breadcrumb */}
      <div className="breadcrumb-area">
        <div className="container">
          <div className="breadcrumb-content">
            <ul>
              <li><Link to="/store">Home</Link></li>
              <li className="active">About Us</li>
            </ul>
          </div>
        </div>
      </div>

      {/* About Wrapper */}
      <div className="about-us-wrapper pt-60 pb-40">
        <div className="container">
          <div className="row">
            {/* About Text */}
            <div className="col-lg-6 order-last order-lg-first">
              <div className="about-text-wrap">
                <h2><span>Welcome to</span> PakPoints Store</h2>
                <p>PakPoints Store is your trusted online marketplace, bringing you quality products from verified sellers across Pakistan. As part of the PakPoints ecosystem, we connect communities through technology, making shopping convenient and reliable.</p>
                <p>We are committed to providing you with the best shopping experience, offering a wide range of products including jewellery, clothing, electronics, home essentials, and much more. All our sellers are verified, ensuring quality and authenticity.</p>
                <p>Our mission is to make online shopping accessible, safe, and enjoyable for everyone in Pakistan. We believe in building trust through transparency, quality products, and excellent customer service.</p>
              </div>
            </div>
            {/* About Image */}
            <div className="col-lg-5 col-md-10">
              <div className="about-image-wrap">
                <img className="img-full" src={imagePath('product/large-size/13.jpg')} alt="About Us" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Counterup Area */}
      <div className="counterup-area">
        <div className="container-fluid p-0">
          <div className="row no-gutters">
            {counters.map((counter, index) => (
              <div key={index} className="col-lg-3 col-md-6">
                <div className={`limupa-counter ${counter.bgClass}`}>
                  <div className="container">
                    <div className="counter-img">
                      <img src={imagePath(counter.icon)} alt={counter.label} />
                    </div>
                    <div className="counter-info">
                      <div className="counter-number">
                        <h3 className="counter">{counter.number}</h3>
                      </div>
                      <div className="counter-text">
                        <span>{counter.label}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </PageContainer>
  );
};

export default AboutUsPage;
